import { NgModule } from '@angular/core';
import { QuestionModule } from '../abstract/question.module';
import { QuestionAfterschoolComponent } from './question-afterschool.component';
import { DndModule } from 'ngx-drag-drop';
import { OptionAfterschoolModule } from '../../options';

@NgModule({
  imports: [
    QuestionModule,
    DndModule,
    OptionAfterschoolModule,
  ],
  declarations:[QuestionAfterschoolComponent],
  exports:[QuestionAfterschoolComponent],
})
export class QuestionAfterschoolModule { }

